<template>
  <div class="cl-sms-code-input">
    <el-input
      :placeholder="mobile ? '请输入短信验证码' : '请输入手机号码'"
      v-model="vModel"
      @input="handleInput"
      maxlength="10"
      :disabled="!mobile || disabled"
    >
    </el-input>
    <div class="cl-sms-code-input-btn">
      <el-button
        @click="openCaptcha"
        :size="buttonSize"
        v-loading="loading"
        type="primary"
        :disabled="!mobile || disabled || count"
      >
        <span v-show="!count">发送</span>
        <count-down
          ref="countDown"
          :end-time="endTime"
          @end="handleEnd"
          v-show="count"
          v-if="endTime"
          simple
          seconds-txt="秒"
        />
      </el-button>
    </div>

    <!-- 随机验证码 -->
    <el-dialog
      :append-to-body="true"
      :visible.sync="captcha.dialog"
      title="图形验证码"
      width="500px"
      v-dialog-drag
      :close-on-click-modal="false"
    >
      <el-row>
        <el-form
          ref="form"
          :model="captcha"
          :rules="captchaRules"
          size="small"
          label-width="100px"
          onsubmit="return false;"
        >
          <el-col :span="24">
            <el-form-item label="图形验证码：" prop="code">
              <el-input
                ref="captchaCode"
                v-model="captcha.code"
                auto-complete="off"
                placeholder="请输入"
                style="width:calc(100% - 140px);"
              >
                <i slot="prefix" class="el-icon-circle-check" />
              </el-input>
              <img
                :src="captcha.codeUrl"
                title="点击刷新"
                @click="getCaptchaCode"
                v-if="captcha.codeUrl"
                style=" right: 20px; top:0; position: absolute;"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="text" @click="captcha.dialog = false">
          取消
        </el-button>
        <el-button :loading="loading" type="primary" @click="captchaSubmit">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CountDown from '../CountDown/countDown'
import request from '../../utils/request'
import RuleUtil from '../../utils/rule'

export default {
  name: 'SmsCodeInput',
  components: { CountDown },
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    mobile: {
      type: String,
      required: true,
      default: ''
    },
    // 来源
    source: {
      type: String,
      required: true,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * 按钮尺寸
     */
    buttonSize: {
      type: String,
      default: null
    },
    // 消息emit
    msg: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      loading: false,
      vModel: null,
      endTime: null,
      count: false,
      captcha: {
        dialog: false,
        verify: null,
        code: null,
        uuid: null,
        check: null,
        codeUrl: null
      },
      captchaRules: {
        code: [{ required: true, trigger: 'change', message: '验证码不能为空' }]
      }
    }
  },
  watch: {
    value() {
      this.vModel = this.value
    }
  },
  created() {
    this.getSmsCodeVerify()
  },
  methods: {
    /**
     * 获取系统配置
     */
    getSmsCodeVerify() {
      request({
        url: '/sys/config/value/sms_code_verify',
        method: 'get'
      }).then(res => {
        this.captcha.verify = res.data
      })
    },
    /**
     * 倒计时结束
     */
    handleEnd() {
      this.count = false
    },
    /**
     * 发送验证码
     */
    handleSend() {
      this.loading = true
      request({
        url: `/sms/code/send`,
        method: 'post',
        params: {
          mobile: this.mobile,
          source: this.source,
          captchaUuid: this.captcha.uuid,
          captchaCode: this.captcha.code
        }
      })
        .then(res => {
          this.loading = false
          if (res.success) {
            this.count = true
            this.endTime = new Date().getTime() + 60 * 1000
            this.$message.success('短信发送成功，请注意查收！')
            if (res.data && res.data.content) {
              this.vModel = res.data.content
              this.handleInput()
            }
          } else if (res.message) {
            this.$emit('msg', res.message)
          }
        })
        .catch(res => {
          this.$emit('msg', res.message)
          this.loading = false
        })
    },
    /**
     * 输入验证码
     */
    handleInput() {
      this.$emit('input', this.vModel)
    },
    /**
     * 获取验证码
     */
    getCaptchaCode() {
      request({
        url: '/auth/captcha',
        method: 'get',
        params: { source: this.source }
      }).then(res => {
        this.captcha.codeUrl = res.data.img
        this.captcha.uuid = res.data.uuid
        this.captcha.code = null
        this.$refs.captchaCode.focus()
      })
    },
    /**
     * 打开图形验证码
     */
    openCaptcha() {
      const msg = RuleUtil.validate(this.mobile, 'mobile')
      if (msg) {
        if (this.msg) {
          this.$emit('msg', '手机号码不正确！')
        } else {
          this.$message.error('手机号码不正确！')
        }
        return
      }
      if (this.captcha.verify === '1') {
        this.captcha.dialog = true
        this.getCaptchaCode()
      } else {
        this.handleSend()
      }
    },
    /**
     * 提交
     */
    captchaSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 关闭图形验证码弹窗
          this.captcha.dialog = false
          this.handleSend()
        }
      })
    }
  }
}
</script>
